import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Bs4Tooltip from '../../Bs4Components/Bs4Tooltip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import { getBs4Style } from '../../Bs4Components/Bs4Utils'

import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Bs4ModalTopCenter from '../../Bs4Components/Bs4ModalTopCenter';

import Bs4Stores from '../../Bs4Stores'
import Bs4MainDispatch from '../../Bs4MainDispatch'
import Bs4GenericField from './Bs4GenericField'
import { SmallScreenContext } from '../../Bs4Theme/Bs4UxTemplates';


export default class Bs4Select extends Bs4GenericField {

  setValueBs4(valueOrg) {
    let value = valueOrg;
    if (Array.isArray(value)) value = value[0];
    if (typeof value === 'undefined') value = null;
    if (!Array.isArray(this.bs4Store)) this.bs4Store = [];
    if (this.bs4CardMainForObject) {
      value = this.getSomeValueFromBs4Store(value, this.bs4Store);
    } else {
      this.bs4Store = Bs4Stores.addUnknownValuesToStore(this.bs4Store, [value]);
      value = this.bs4Store.find(item => item.id == value);
      if (typeof value === 'undefined') value = null;
    }    
    this.setValue(value);
  }

  getValueBs4 () {    
    return this.getValue()?.id || '';
  }

  isDifferentValues (oldValue, newVaue) {
    return oldValue?.id != newVaue?.id;
  }

  isNativelyClearable () {
    return true;
  }

  getShortValue = () => {
    return this.getValue()?.name;
  }

  ViewSummaryDetails = (props) => {
    const formField = this;
    return <formField.ViewComponentFieldAutocomplete SummaryDetails/>;    
  }

  ViewOptionIcon = (props) => {
    const theme = useTheme();
    if (props?.option &&  !('bs4Style' in props.option)) props.option.bs4Style = getBs4Style(props?.option?.style) || null
    // if (props.option.bs4Style && !props.option.icon) props.option.icon = 'fa-solid fa-circle';
    if (props.option?.icon) {
      return (
        <Bs4Tooltip arrow title={
          <React.Fragment>
            <Typography variant='body1'>{props?.option?.name}</Typography>
            <Typography variant='body2' sx={{whiteSpace: 'pre-line'}}>{props?.option?.text}</Typography>
          </React.Fragment>
          }
        >
          <Box 
            sx={{        
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              //width: 26, 
              //height: 26, 
              padding: 0.3,
              borderRadius: theme.shape.borderRadius+'px',
              ...props?.option?.bs4Style,
            }}
          >
            <Box className={props.option?.icon}/>
          </Box>
        </Bs4Tooltip>
      )       
    }
    return null
  };

  ViewOption = (props) => {
    const formField = this;    
    if (props?.option &&  !('bs4Style' in props.option)) props.option.bs4Style = getBs4Style(props?.option?.style) || null

    return (
      <Stack
        component='li'
        {...props.props}
        direction='row'
        justifyContent='flex-start'
        alignItems= 'flex-start'//'center'
        spacing={1}        
      >
        <formField.ViewOptionIcon option={props.option}/>
        <Stack component='span' direction='column' justifyContent='flex-start' alignItems='flex-start' spacing={0}>
          <Typography>{props?.option?.name}</Typography>
          {props?.option?.text ? <Typography variant='body2' sx={{whiteSpace: 'pre-line', opacity: 0.7}}>{props?.option?.text}</Typography> : null}
        </Stack>
      </Stack>
    )
  };

  ViewComponentField = (props) => {
    const formField = this;
    const [adornmentVisibility, setAdornmentVisibility] = React.useState('hidden');   
    
    const handleAdd = (e) => {
      Bs4MainDispatch.commandParser('Bs4FieldIconPlus', { currFormId: this.props.field.formId }, this.bs4KartotekaId);
    }

    return (
      <Box 
        width='100%'
        sx={{display: 'flex', alignItems: 'flex-end'}}
        onMouseEnter={() => setAdornmentVisibility('visible')} 
        onMouseLeave={() => setAdornmentVisibility('hidden')}
      >                
        <formField.ViewComponentFieldAutocomplete {...props}/>
        {formField.isParamSelected('ATRYB_PLUS') &&
          <IconButton onClick={handleAdd}>
            <AddIcon fontSize='small' sx={{visibility: adornmentVisibility}}/>
          </IconButton> 
        }
      </Box>
    );
  }

  PopperStandard = (props) => {      
      return (<Popper {...props} style={{ width: 250 }} placement='bottom-start'/>)
    }
    
  PopperDialogFlat = (props) => {
    return (
      <Box {...props.style} width={'100%'}>
        {props.children}
      </Box>
    )
  }

  PopperDialog = (props) => {
    const formField = this;
      
    return (
      <Bs4ModalTopCenter
        bs4KartotekaId={formField.bs4KartotekaId}
        open={props.open}
        onClose={props.onClose}
      >
        <formField.ViewComponentField {...props} variantDialog/>
      </Bs4ModalTopCenter>
    )
  }

  PaperComponent = (props) => {
    const formField = this;
    const { children, ...restPaperProps } = props;
    const variantDialog = Boolean(props.bs4config.variantDialog);
    const edStoreBs4 = this.props.field.ed_storebs4;         
    
    const handleEditList = (e) => {
      const details = formField.props.criterion
      ? {currFormId: formField.props.field.formId, targetObject: this.props.field.ed_storebs4, targetOption: 343}
      : {currFormId: formField.props.field.formId, targetObject: this.props.field.ed_storebs4, targetOption: 343}; 
      Bs4MainDispatch.commandParser('Bs4OpenCard', details, this.bs4KartotekaId);
    };    
        
    const PaperBox = variantDialog ? Box : Paper;

    return (
      <PaperBox {...restPaperProps}>
        {Boolean(edStoreBs4) ? 
          <MenuItem divider
            onMouseDown={(e) => e.preventDefault()} // prevent blur
            onClick={(e) => {
              e.preventDefault(); // prevent blur
              handleEditList();
            }}
          >
            {/* <Checkbox size='small' checked={false} sx={{visibility: 'hidden'}}/> */}
            <ListItemText secondary={formField.text_EditList}/>
          </MenuItem>
        : null}              
        {children}
      </PaperBox>
    );
  }

  ViewComponentFieldAutocomplete = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR);
    const [newBs4Store, setBs4Store] = React.useState(formField.bs4Store || []);
    const bs4Store = React.useMemo(() => {
      return this.bs4Store.map(option => {
        if (option.style && !option.icon) option.icon = 'fa-solid fa-circle';
        return option;
      });
    }, [newBs4Store])

    this.refFocus = React.useRef();

    const [open, setOpen] = React.useState(false);
    const smallScreen = React.useContext(SmallScreenContext);
    const popper = React.useMemo(() => {
      if (props.variantDialog) return this.PopperDialogFlat;
      if (smallScreen) return this.PopperDialog;
      return this.PopperStandard;
    }, [smallScreen, props.variantDialog]);

    React.useEffect(() => {
      this.notValidElementDom = (text) => {
        setError({error: true, helperText: text})
      }

      const CHANGE = (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      };
      this.on(Bs4GenericField.CHANGE, CHANGE);

      const CHANGE_STORE = (bs4Store) => {
        setBs4Store(bs4Store);
        this.setValueBs4(this.getValueBs4());
      }
      this.on(Bs4GenericField.CHANGE_STORE, CHANGE_STORE);

      return () => {        
        this.off(CHANGE);
        this.off(CHANGE_STORE);
      }
    }, [error, value, setError, setValue, setBs4Store]);

    const handleChange = (event, newValue) => {
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
      this.setValue(newValue);
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
      if (props.SummaryDetails) this.reloadGridCriteria();
    }    

    const popupIcon = React.useMemo(() => {
      if (props.variantDialog) return {popupIcon: null}      
      return {};
    }, [props.variantDialog]);

    const handleOpenAutocomplete = React.useCallback((event) => {
          setOpen(true);
        }, [setOpen]);
    
    const handleCloseAutocomplete = React.useCallback((event, reason) => {
      if ((reason === 'blur' || reason === 'toggleInput') && popper === this.PopperDialog) return;  
      setOpen(false);
      if (props.onClose) props.onClose(event, reason);
    }, [setOpen, popper]);

    return (    
      <Stack 
        direction="column" 
        spacing={0} 
        sx={{justifyContent: "flex-start", alignItems: "flex-start", width: props.SummaryDetails ? 'auto' : '100%', minWidth: props.variantDialog ? 200 : 'auto'}}
      >
        <Autocomplete
          open={open || Boolean(props.variantDialog)}
          {...popupIcon}
          onOpen={handleOpenAutocomplete}
          onClose={handleCloseAutocomplete}
          readOnly={this.readOnly}
          freeSolo={this.readOnly}
          fullWidth={!props.SummaryDetails}
          sx={{
            minWidth : props.SummaryDetails ? 180 : 'auto',
          }}          
          value={value}
          disableClearable={!formField.props.criterion}
          onChange={handleChange}
          options={bs4Store}
          getOptionLabel={option => option?.name}
          isOptionEqualToValue={(option, value) => option.id === value.id}          
          renderInput={params => {
            params.InputProps.disableUnderline = formField.readOnly;
            if (value?.icon) {   
              //2023-05-23 dla variant='filled' prawdopodobnie błąd mui.com
              params.InputProps.startAdornment = (
                <InputAdornment position='start' sx={{marginTop: 0}}>
                  <formField.ViewOptionIcon option={value}/>
                </InputAdornment>
              );
            }
            return (
            <TextField
              {...params}               
              label={props.SummaryDetails ? null : <formField.Bs4Label/>} 
              slotProps={{inputLabel: formField.props.field.hideLabel ? {sx:{display:'none'}} : null}}
              inputRef={this.refFocus} 
              error={error.error} 
              helperText={error.helperText}        
            />
          )}}         
          renderOption={(props, option, state) => {
            return <formField.ViewOption key={option.id} props={props} option={option}/>
          }}
          slots={{
            paper: formField.PaperComponent,
            popper: popper,
          }} 
          slotProps={{
            paper: {
              value: value,
              onClose: handleCloseAutocomplete,
              bs4config: {variantDialog: props.variantDialog},
            },
            popper: {        
              sx: { minWidth: 'fit-content' },
              onClose: handleCloseAutocomplete,
            }
          }}          
        />
      </Stack>  
    );
  }
}